// quick-view.js
// Modified to preserve & pass variant query params into quick view modal
// and to read selected variant from the card wrapper before opening the drawer.

class QuickViewDrawer extends MenuDrawer {
  constructor() {
    super();

    this.setClasses({
      open: 'quick-view--open',
      opening: 'quick-view--opening',
      closing: 'quick-view--closing'
    });

    this.addEventListener('close', () => {
      const drawerContent = this.querySelector('.quick-view__content');
      drawerContent.innerHTML = '';
      drawerContent.classList.remove('hide-cover');

      document.dispatchEvent(new CustomEvent('quickview:close'));
    });
  }
}
customElements.define('quick-view-drawer', QuickViewDrawer);

class QuickViewButton extends MenuDrawer {
  constructor() {
    super();

    this.addEventListener('click', () => {
      // Attempt to append a selected variant (if present) to data-product-url
      try {
        const wrapper = this.closest('.card-wrapper');
        // look for selected variant stored on the wrapper (set by variant links/buttons)
        let selectedVariant = wrapper && wrapper.dataset && wrapper.dataset.selectedVariant ? wrapper.dataset.selectedVariant : null;

        // fallback to a default provided on the button itself
        if (!selectedVariant && this.dataset && this.dataset.defaultVariant) {
          selectedVariant = this.dataset.defaultVariant;
        }

        // If we have a selectedVariant and a base productUrl, update dataset.productUrl preserving other query params
        if (selectedVariant && this.dataset && this.dataset.productUrl) {
          try {
            const u = new URL(this.dataset.productUrl, window.location.origin);
            u.searchParams.set('variant', selectedVariant);
            // keep relative path + search (same format used by the theme)
            this.dataset.productUrl = u.pathname + (u.search || '');
          } catch (err) {
            // fallback simple concat/replace
            const base = this.dataset.productUrl.split('?')[0];
            this.dataset.productUrl = base + '?variant=' + selectedVariant;
          }
        }
      } catch (e) {
        // Don't block Quick View if something goes wrong here
        console && console.error && console.error('QuickViewButton variant append error', e);
      }

      // proceed with existing logic
      const wrapper = this.closest('.card-wrapper');
      const drawer = wrapper && wrapper.querySelector('quick-view-drawer');
      if (drawer) {
        drawer.querySelector('summary').click();

        document.dispatchEvent(new CustomEvent('quickview:open', {
          detail: {
            productUrl: this.dataset.productUrl
          }
        }));
      }
      else if (this.dataset.productUrl) {
        window.location.href = this.dataset.productUrl;
      }
    });
  }
}
customElements.define('quick-view-button', QuickViewButton);

class QuickView extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, _observer) {
    if (!entries[0].isIntersecting) return;

    const selector = '.quick-view__content';
    const drawerContent = this.querySelector(selector);

    // Preserve any existing query params (e.g. ?variant=123) and ensure view=modal is present.
    let productUrl = this.dataset.productUrl || '';
    let sectionUrl;
    try {
      const u = new URL(productUrl, window.location.origin);
      // Ensure view=modal exists
      u.searchParams.set('view', 'modal');
      sectionUrl = u.pathname + (u.search || '');
    } catch (err) {
      // Fallback: if productUrl already has ?, append &view=modal otherwise ?view=modal
      if (productUrl.indexOf('?') === -1) sectionUrl = productUrl + '?view=modal';
      else sectionUrl = productUrl + '&view=modal';
    }

    fetch(sectionUrl)
      .then(response => response.text())
      .then(responseText => {
        setTimeout(() => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          const productElement = responseHTML.querySelector(selector);

          // Guard: productElement may be null if response malformed
          if (productElement) {
            this.setInnerHTML(drawerContent, productElement.innerHTML);
          } else {
            // If productElement not found, insert raw response (safe fallback)
            drawerContent.innerHTML = responseText;
          }

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
        }, 200);

        setTimeout(() => {
          drawerContent.classList.add('hide-cover');

          document.dispatchEvent(new CustomEvent('quickview:loaded', {
            detail: {
              productUrl: this.dataset.productUrl
            }
          }));
        }, 500);
      })
      .catch(e => {
        console.error(e);
      });
  }

  setInnerHTML(element, html) {
    element.innerHTML = html;

    // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
    element.querySelectorAll('script').forEach(oldScriptTag => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach(attribute => {
        newScriptTag.setAttribute(attribute.name, attribute.value)
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}
customElements.define('quick-view', QuickView);

